import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import Alert from 'src/components/atoms/alert'
import Button from 'src/components/atoms/button'
import Input from 'src/components/atoms/input'
import Form, { FormItem } from 'src/components/forms'
import { routes } from 'src/routes/routes'

interface Props {
    submitting: boolean
    error?: boolean
    onSubmit: (email: string, password: string) => void
    onBack: () => void
}

export default function LoginForm(props: Props) {
    const { onSubmit, submitting, error, onBack } = props

    const location = useLocation()
    const { t } = useTranslation()

    return (
        <div data-testid="login-form" className="w-full">
            <Form
                disabled={submitting}
                layout="vertical"
                onFinish={(values) => onSubmit(values.username, values.password)}
                className="w-full"
                initialValues={{ username: location?.state?.username || '' }}
            >
                <div className="mb-6">
                    <FormItem
                        rules={[{ required: true, message: t('Please add e-mail') }]}
                        label={t('E-mail')}
                        name="username"
                    >
                        <Input data-testid="test-username" autoFocus size="large" placeholder={t('Enter e-mail')} />
                    </FormItem>
                </div>

                <FormItem
                    rules={[{ required: true, message: t('Please add password') }]}
                    label={t('Password')}
                    name="password"
                >
                    <Input
                        data-testid="test-password"
                        size="large"
                        type="password"
                        placeholder={t('Enter your password')}
                    />
                </FormItem>

                <FormItem shouldUpdate className="ml-3 mt-2">
                    {(form) => (
                        <Link
                            to={routes.FORGOT_PASSWORD}
                            state={{ username: form.getFieldValue('username') }}
                            className="text-[14px] text-gray-900 underline transition hover:text-gray-800"
                        >
                            {t('Forgot password?')}
                        </Link>
                    )}
                </FormItem>

                {error ? (
                    <Alert
                        message={t('There is no user found with the given credentials.')}
                        type="error"
                        data-testid="error-login"
                        className="mt-4"
                    />
                ) : null}

                <FormItem className="mb-0 mt-6">
                    <Button htmlType="submit" type="primary" block disabled={submitting} loading={submitting}>
                        {t('Log in', 'Log in')}
                    </Button>
                </FormItem>
            </Form>

            <div className="mt-2 flex w-full items-center justify-center">
                <Button type="text" block onClick={onBack}>
                    {t('Back')}
                </Button>
            </div>
        </div>
    )
}
